/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:integration_id/fetch_product_metafields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyIntegrationIdFetchProductMetafields } from "./constants";
import type { GetAlloysPartnersShopifyIntegrationIdFetchProductMetafieldsResult } from "./types";
import { isGetAlloysPartnersShopifyIntegrationIdFetchProductMetafieldsResult } from "./validators";

export const getAlloysPartnersShopifyIntegrationIdFetchProductMetafields = reactQueryFetcherAdapter(
  alloysPartnersShopifyIntegrationIdFetchProductMetafields,
  (
    signal: AbortSignal,
    integrationId: string
  ): Promise<GetAlloysPartnersShopifyIntegrationIdFetchProductMetafieldsResult> => {
    return fetch(`/alloys/partners/shopify/${integrationId}/fetch_product_metafields`, "GET", {}, { signal });
  },
  isGetAlloysPartnersShopifyIntegrationIdFetchProductMetafieldsResult
);
